
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import { Form, useActionData, useNavigate, useNavigation } from "react-router-dom";
import { Container, colors } from "@mui/material";
import { ToastContainer } from "react-toastify";
import { useForm } from "react-hook-form";

export default function ActivateAccount() {
    const navigation = useNavigation();
    const inputDisabled = navigation.state === "submitting";
    const error = useActionData() as string | undefined;

    const { formState: { isSubmitting, errors } } = useForm();

    return (
        <Container component="main">
            <Grid container  sx={{ justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
                <CssBaseline />
                    <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                    <Box
                        sx={{
                            my: 8,
                            mx: 4,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >
                        
                        <Typography component="h1" variant="h5"> Activate your account </Typography>

                        {/* =============================== Activate form account ==============================*/}
                        <Box component={Form} method="post" sx={{ mt: 1 }}>
                            {/* ============ activation code input ===== */}
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="activation_code"
                                label="activation code"
                                name="activation_code"
                                autoComplete="activation_code"
                                autoFocus
                                disabled={inputDisabled}
                            />


                            {/* Message toast */}
                            <ToastContainer />
                            
                            {/* Login button */}
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2, backgroundColor: "#00008B" }}
                                disabled={inputDisabled}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    {inputDisabled ? <CircularProgress size={16} /> : "Activate"}
                                </Box>
                            </Button>
                        </Box>
                    </Box>
                </Grid>
            </Grid>

        </Container>
    );
}
